module.exports = __webpack_public_path__ + "assets/img/message.462789e4.png";